// One public snapshot feeds the list and ticker. Dates always use restaurant time.
function prostEventDay(now) {
  const parts=new Intl.DateTimeFormat('en-US',{timeZone:'America/Detroit',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date(now));
  const value=t=>parts.find(p=>p.type===t).value;
  return `${value('year')}-${value('month')}-${value('day')}`;
}
function prostUpcomingEvents(events,location,now=Date.now()) {
  if(!Array.isArray(events))return [];
  const seen=new Set();
  return events.filter(event=>{
    if(!event || event.location!==location || typeof event.id!=='string' || seen.has(event.id) || typeof event.title!=='string' || !event.title.trim())return false;
    const start=Date.parse(event.start_at),end=Date.parse(event.end_at);
    if(!Number.isFinite(start)||!Number.isFinite(end)||end<=start||end<=now)return false;
    if(!/^\d{4}-\d{2}-\d{2}$/.test(event.starts_on||'')||!/^\d{4}-\d{2}-\d{2}$/.test(event.ends_on||''))return false;
    seen.add(event.id);return true;
  }).sort((a,b)=>Date.parse(a.start_at)-Date.parse(b.start_at));
}
function prostSelectEvent(events,location,now=Date.now()) {
  const upcoming=prostUpcomingEvents(events,location,now),today=prostEventDay(now);
  const sameDay=upcoming.filter(e=>e.starts_on<=today&&e.ends_on>=today);
  if(sameDay.length)return {kind:'today',event:sameDay.find(e=>Date.parse(e.start_at)<=now)||sameDay[0]};
  // This week means the restaurant-local Sunday–Saturday calendar week.
  const date=new Date(today+'T12:00:00Z');
  date.setUTCDate(date.getUTCDate()+6-date.getUTCDay());
  const weekEnd=date.toISOString().slice(0,10);
  const event=upcoming.find(e=>e.starts_on>today&&e.starts_on<=weekEnd);
  return event?{kind:'week',event:event}:{kind:'none',event:null};
}
if(typeof customElements!=='undefined'&&!customElements.get('prost-event-ticker')) {
  customElements.define('prost-event-ticker',class extends HTMLElement {
    connectedCallback(){
      this.update=()=>{
        let events;try{events=JSON.parse(this.querySelector('script[type="application/json"]').textContent);}catch(_){events=[];}
        const selected=prostSelectEvent(events,this.dataset.location);
        const section=this.closest('.prost-event-ticker-section');
        if(section){
          section.hidden=!selected.event;
          const inactive=section.hidden||section.classList.contains('is-leaving');
          section.inert=inactive;
          section.setAttribute('aria-hidden',String(inactive));
        }
        const text=this.querySelector('[data-ticker-text]');
        text.textContent=selected.event?selected.event.title:this.dataset.emptyLabel;
        const status=this.querySelector('[data-ticker-status]'),date=this.querySelector('[data-ticker-date]'),action=this.querySelector('[data-ticker-action]');
        if(status){status.hidden=!selected.event;status.dataset.kind=selected.kind;status.textContent=selected.kind==='today'?this.dataset.todayLabel:this.dataset.weekLabel;}
        if(date){date.hidden=!selected.event;date.textContent=selected.event?.date_label||'';}
        if(action)action.hidden=!selected.event;
      };
      this.update();clearInterval(this.timer);this.timer=setInterval(this.update,60000);
    }
    disconnectedCallback(){clearInterval(this.timer);}
  });
}
